import endlessRunnerGif from "../../assets/game_images/EndlessRunner.gif";
import gameFootballGif from "../../assets/game_images/gameFootball.gif";
import fruitninjaGif from "../../assets/gifs/fruit_ninja/left_cut.gif";
// import language_toggle from "../../assets/images/language_toggle.png";
// import yoga_upcoming from "../../assets/images/yoga_upcoming.png";
import boxing_game from "../../assets/images/boxing_game.png";
import tennis_game from "../../assets/images/tennis_game.png";
// import physiotherapy_coming_soon from "../../assets/images/physiotherapy_coming_soon.png";
// import buddy_workout from "../../assets/images/buddy_workout.png";
// import getactyv_app from "../../assets/images/getactyv_app.png";
import FranticNinjaGameGif from "../../assets/game_images/FranticNinjaGame.gif";
import { useEffect, useState } from "react";
// import {
//   getAllModules,
//   // getMyProgramV2,
//   // getPlaylistDetails,
//   // getUserPlaylist,
//   getUserPlaylistDetails,
// } from "../../api/api";
import { useLocation, useNavigate } from "react-router-dom";
// import {
//   MemoizedPlaylists,
//   Playlists,
//   PlaylistSidePanel,
//   SharedUserPlaylistDialog,
//   SkeletonPlaylist,
// } from "./Playlists";
import { BlueTextLinearGradient, WhiteLinearGradient } from "../../utils/Utils";
// import { SkeletonPrograms } from "../programs/Programs";
// import { MainPrograms } from "../programs/MainProgramCard";
// import { useAuthContext } from "../../context/AuthContext";

export default function DashboardHome() {
  // const location = useLocation();
  // const [userPlaylists, setUserPlaylists] = useState([]);
  // const [modules, setModules] = useState();
  // const [programs, setPrograms] = useState();

  // async function updateModules() {
  //   const response = await getAllModules();
  //   if (response) setModules(response);
  // }
  // async function updateUserPlaylists() {
  //   const response = await getUserPlaylist();
  //   if (response) setUserPlaylists(response);
  //   else setUserPlaylists([]);
  // }
  // async function updatePrograms() {
  //   const response = await getMyProgramV2();
  //   if (response) setPrograms(response);
  // }
  // const auth = useAuthContext();
  // useEffect(() => {
  //   updateModules();
  //   // updateUserPlaylists();
  //   // updatePrograms();
  //   window.scrollTo(0, 0);
  // }, []);

  // const [showShareDetails, setShowShareDetails] = useState(false);
  // const [shareRoutine, setShareRoutine] = useState();
  // const [shareUserPlaylist, setShareUserPlaylist] = useState();
  // useEffect(() => {
  //   updatePrograms();
  // }, []);

  // const getShareDetails = async () => {
  //   if (location.search) {
  //     const query = new URLSearchParams(location.search);
  //     if (query.get("routineId")) {
  //       let response = await getPlaylistDetails(query.get("routineId"));
  //       const list = [];
  //       response.exercises.forEach((element) => {
  //         list.push({
  //           exerciseName: element.exerciseName,
  //           description: element.exercisesBenefits,
  //           exerciseUri: element.exerciseURI,
  //           id: element.exerciseId,
  //           exerciseImage: element.activityImage,
  //           exerciseVideo: element.exerciseVideo,
  //           exerciseAudio: element.exerciseAudio,
  //         });
  //       });
  //       response.exercises = list;
  //       setShareRoutine(response);
  //       setShowShareDetails(true);
  //     } else if (query.get("userPlaylistId")) {
  //       let response = await getUserPlaylistDetails(
  //         query.get("userPlaylistId")
  //       );
  //       const list = [];
  //       response.exercises.forEach((element) => {
  //         list.push({
  //           exerciseName: element.exerciseName,
  //           description: element.exercisesBenefits,
  //           exerciseUrl: element.exerciseURI,
  //           exerciseId: element.exercises_id,
  //           exerciseImage: element.activityImage,
  //           exerciseVideo: element.exerciseVideo,
  //           exerciseAudio: element.exerciseAudio,
  //         });
  //       });

  //       response.exercises = list;
  //       setShareUserPlaylist(response);
  //       setShowShareDetails(true);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   getShareDetails();
  // }, []);

  return (
    <>
      {/* {shareRoutine && (
        <PlaylistSidePanel
          playlist={{
            playlistName: shareRoutine.playlistName,
            playlistId: shareRoutine.playlistId,
            playlistCat: shareRoutine.playlistCat,
            playlistShortUrl: shareRoutine.playlistShortUrl,
            playlistExerciseId: shareRoutine.playlistExerciseId,
            description: shareRoutine.description,
            badgeText: shareRoutine.badgeText,
            duration: shareRoutine.duration || shareRoutine.time,
            activityImage: shareRoutine.activityImage,
            mainName: shareRoutine.mainName,
            subName: shareRoutine.subName,
            playlistVideo: shareRoutine.playlistVideo,
            playlistAudio: shareRoutine.playlistAudio,
            playlistUrl: shareRoutine.url,
          }}
          exercises={shareRoutine.exercises || []}
          show={showShareDetails}
          closeSideBar={() => {
            setShowShareDetails(false);
          }}
        />
      )}
      {shareUserPlaylist && (
        <SharedUserPlaylistDialog
          playlist={{
            playlistName: shareUserPlaylist.playlistName,
            playlistId: shareUserPlaylist.playlistId,
            playlistShortUrl: shareUserPlaylist.playlistShortUrl,
            playlistUrl: shareUserPlaylist.url,
            user_name: shareUserPlaylist.user_name,
          }}
          exercises={shareUserPlaylist.exercises}
          show={showShareDetails}
          close={() => {
            setShowShareDetails(false);
          }}
          onPlaylistAdded={() => {
            updateUserPlaylists();
          }}
        />
      )} */}
      <div
      // style={{
      //   background: "linear-gradient(148deg, #FFFFFF 0.72%, #E1E4F1 100%)",
      // }}
      // className={`w-full bg-[#0E0E11]`}
      >
        {/* {programs ? (
          programs?.length > 0 && (
            <>
              <p
                className={`font-semibold text-4xl ${BlueTextLinearGradient} px-6 md:px-16 mt-10 lg:px-24 2xl:px-32`}
              >
                {`Hi ${auth.state.user.fullname.split(" ")[0]}`}
              </p>
              <p
                className={`font-medium text-2xl mt-2 ${BlueTextLinearGradient} px-6 md:px-16 lg:px-24 2xl:px-32`}
              >
                {"Here is your recommended programs."}
              </p>
              <div className="px-6 md:px-16 lg:px-24 2xl:px-32 mt-10 ">
                <MainPrograms programs={programs} />
              </div>
            </>
          )
        ) : (
          <div className="px-6 md:px-16 lg:px-24 2xl:px-32">
            <SkeletonPrograms />
          </div>
        )} */}
        <div className="md:px-24 px-10">
          <GamesSection />
          {/* <UpcomingFeaturesSection /> */}
        </div>
      </div>
    </>
  );
}

// function UpcomingFeaturesSection() {
//   const features = [
//     {
//       title: "Yoga",
//       image: yoga_upcoming,
//     },
//     {
//       title: "Physiotherapy",
//       image: physiotherapy_coming_soon,
//     },
//     {
//       title: "Buddy Workout",
//       image: buddy_workout,
//     },
//     {
//       title: "Getactyv App",
//       image: getactyv_app,
//     },
//     {
//       title: "Language Toggle",
//       image: language_toggle,
//     },
//   ];
//   return (
//     <div className={`rounded-t-xl flex flex-col mb-10`}>
//       <p className={`${BlueTextLinearGradient} font-medium text-2xl my-8 z-0 `}>
//         Upcoming Modules
//       </p>
//       <div className="grid grid-cols-2 md:grid-cols-3  gap-5 ">
//         {features.slice(0, 2).map((feature, index) => {
//           return <UpcomingFeature {...feature} key={index} />;
//         })}
//       </div>

//       <p className={`${BlueTextLinearGradient} font-medium text-2xl my-8 z-0 `}>
//         Upcoming Features
//       </p>
//       <div className="grid grid-cols-2 md:grid-cols-3  gap-5 ">
//         {features.slice(2).map((feature, index) => {
//           return <UpcomingFeature {...feature} key={index} />;
//         })}
//       </div>
//     </div>
//   );
// }

// function UpcomingFeature({ title, image }) {
//   return (
//     <div
//       className="flex flex-row w-full h-44 md:h-[350px] rounded-xl bg-primary-gray bg-center bg-no-repeat  bg-cover justify-center items-end p-5 "
//       style={{ backgroundImage: `url(${image})` }}
//     >
//       <p className="flex text-primary-neonGreen font-extrabold italic md:text-2xl text-center">
//         {title}
//       </p>
//     </div>
//   );
// }

export function GamesSection() {
  const navigate = useNavigate();

  const handleRedirectToGame = () => {
    navigate(`/game/@1`);
  };
  const handleRedirectToFootball = () => {
    navigate(`/game/@2`);
  };
  const handleRedirectToEndlessRunner = () => {
    navigate(`/game/@3`);
  };
  const handleRedirectToFruitNinja = () => {
    navigate(`/game/@4`);
  };

  function Game({ gif, title, onClick, comingSoon }) {
    return (
      <div
        className={`h-[200px] rounded-xl z-5  ${
          !comingSoon
            ? "hover:scale-110  transform duration-500 cursor-pointer"
            : ""
        } bg-cover bg-center bg-no-repeat ease-in-out col-span-1`}
        style={{ backgroundImage: `url(${gif})` }}
        onClick={onClick}
      >
        <div className="flex flex-col items-center justify-center h-full rounded-xl bg-opacity-60 bg-black px-6 py-4 uppercase">
          <p className="text-center text-primary-neonGreen italic font-extrabold text-xl ">
            {title}
          </p>
          {comingSoon && (
            <p className="text-center text-primary-white font-bold text-lg ">
              Coming Soon
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <p
        className={`text-white hidden md:block font-medium text-2xl mb-8 -z-0`}
      >
        Gamified <span className="text-primary-neonGreen">Fitness</span>
      </p>
      <div className="md:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 -z-0 gap-5 mb-10 hidden ">
        <Game
          gif={endlessRunnerGif}
          onClick={handleRedirectToEndlessRunner}
          title="Endless Runner"
        />
        <Game
          gif={gameFootballGif}
          onClick={handleRedirectToFootball}
          title="Football"
        />
        <Game
          gif={FranticNinjaGameGif}
          onClick={handleRedirectToGame}
          title="Frantic Ninja"
        />
        <Game
          gif={fruitninjaGif}
          onClick={handleRedirectToFruitNinja}
          title="Fruit Chopper"
        />
        <Game
          gif={boxing_game}
          // onClick={handleRedirectToGame}
          title="Boxing"
          comingSoon
        />
        <Game
          gif={tennis_game}
          // onClick={handleRedirectToGame}
          title="Tennis"
          comingSoon
        />
      </div>
    </>
  );
}
